export const SITE_NAV = [
  { to: "/", label: "Home", protected: false },
  { to: "/markets", label: "Markets", protected: false },
  { to: "/fees", label: "Fees", protected: false },
  { to: "/blog", label: "Blog", protected: false },
  { to: "/p2p", label: "P2P", protected: true },
  { to: "/otc", label: "OTC", protected: true },
  { to: "/wallets", label: "Wallets", protected: true },
  { to: "/contact", label: "Contact us", protected: false },
];

export const PROFILE_LINKS = [
  { to: "/profile", label: "Dashboard", exact: true },
  { to: "/profile/kyc", label: "KYC verification" },
  { to: "/profile/history", label: "Transaction history" },
  { to: "/profile/tax", label: "Tax & TDS" },
  { to: "/profile/transfer", label: "Deposit / withdrawal" },
  { to: "/profile/sessions", label: "Activity sessions" },
  { to: "/profile/settings", label: "Settings" },
  { to: "/profile/rewards", label: "Rewards & bonuses" },
];

export function isNavActive(pathname, to) {
  if (to === "/") return pathname === "/";
  return pathname === to || pathname.startsWith(`${to}/`);
}

export function isProfileLinkActive(pathname, link) {
  return link.exact ? pathname === link.to : isNavActive(pathname, link.to);
}
